export default __webpack_public_path__ + "static/media/ballrolls.b29dffd6.svg";